var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "参考酒店新增",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-top": "0.1rem" } },
            [
              _c("div", { staticClass: "typeDiv" }, [
                _c(
                  "div",
                  {
                    class: _vm.checkState == 0 ? "checkType" : "",
                    on: {
                      click: function ($event) {
                        _vm.checkState = 0
                      },
                    },
                  },
                  [_vm._v("酒店")]
                ),
                _c(
                  "div",
                  {
                    class: _vm.checkState == 4 ? "checkType" : "",
                    on: {
                      click: function ($event) {
                        _vm.checkState = 4
                      },
                    },
                  },
                  [_vm._v("餐厅")]
                ),
              ]),
              _c(
                "div",
                [
                  _c(
                    "el-checkbox",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkState == 0,
                          expression: "checkState==0",
                        },
                      ],
                      on: { change: _vm.allCheckMethod },
                      model: {
                        value: _vm.allCheck,
                        callback: function ($$v) {
                          _vm.allCheck = $$v
                        },
                        expression: "allCheck",
                      },
                    },
                    [_vm._v("全选")]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.checkState == 4,
                          expression: "checkState==4",
                        },
                      ],
                      on: { change: _vm.allCheckMethod },
                      model: {
                        value: _vm.allCheck1,
                        callback: function ($$v) {
                          _vm.allCheck1 = $$v
                        },
                        expression: "allCheck1",
                      },
                    },
                    [_vm._v("全选")]
                  ),
                  _c("span", [_vm._v("    " + _vm._s(_vm.resourceObj.nameCn))]),
                ],
                1
              ),
              _vm._l(_vm.productList, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticStyle: { "margin-top": "0.1rem" } },
                  [
                    item.state == _vm.checkState
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-checkbox",
                              {
                                model: {
                                  value: item.isCheck,
                                  callback: function ($$v) {
                                    _vm.$set(item, "isCheck", $$v)
                                  },
                                  expression: "item.isCheck",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateFormatYMD(item.stayDate, "-")
                                  ) +
                                    "  " +
                                    _vm._s(item.resourceName)
                                ),
                              ]
                            ),
                            item.referResource.length > 0
                              ? _c("span", [_vm._v("   已选参考酒店：")])
                              : _vm._e(),
                            _vm._l(
                              item.referResource,
                              function (item1, index1) {
                                return _c("span", { key: index1 }, [
                                  _vm._v(_vm._s(item1.nameCn) + " "),
                                  _c("i", {
                                    staticClass: "el-icon-remove-outline",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteResource(item, index1)
                                      },
                                    },
                                  }),
                                ])
                              }
                            ),
                            _vm._v("  "),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }